<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
		<div class="back_left" @click="$router.back()"></div>
		<div class="big_tit">{{$t('income.title3')}}</div>
		<div class="top_right" @click="$router.push('/order')">
			<van-icon name="bars" size="25"/>
		</div>
    </div>
	<div class="head-tabs">
	    <a href="#/vip" class="tab-item ">{{$t('income.title2')}}</a>
	    <a href="#/item" class="tab-item active">{{$t('income.title3')}}</a>
	    <a href="#/order" class="tab-item">{{$t('income.investr')}}</a>
	</div>
	<div class="invest">
		<div class="intsbox notes_box" v-for="i in data.list" :key="i.id" @click="$router.push('/item/'+i.id)">
			<p class="timer">
				<span style="overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;font-size: 14px;color: #333333;font-weight: bold;">
					{{ i[lang] }}
				</span>
				<button class="sub_btn" v-if="i.percent<100" type="button" @click="$router.push('/doinvest/'+i.id)">{{$t('utils.invest')}}</button>
			</p>
			<div class="itembox">
				<div class="thumb">
					<!-- <img @click="$router.push('/item/'+i.id)" :src="i.img" > -->
					<img v-if="i.img.length>10" @click="$router.push('/item/'+i.id)"
						:src="i.img" >
					<img v-else @click="$router.push('/item/'+i.id)" src="../images/shop2/pro.jpg" >
				</div>
				<div class="intro">
					<p>{{$t('investdetail.cycle')}}:<span>{{i.day}}</span>{{$t('investdetail.days')}}</p>
					<p>{{$t('investdetail.dayrate')}}:<span >{{i.rate}}</span>%</p>
					<p>{{$t('investdetail.starting')}}:<span>{{i.min}}</span> {{utils_moneyMark()}}</p>
				</div>
				<div v-if="i.percent>=100" class="sicon">
					<img src="../images/shop2/saleout.png" draggable="false">
				</div>
			</div>	
		</div>
	</div>
	
	
  </div>
</template>
<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import {Tab, Tabs, Progress, Empty, Dialog, Field,Icon} from 'vant';

Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field).use(Icon);
export default {
  name: "item",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      tabs: [
        {name:0,title:this.$t('item.all')}
      ],
      active: 0,
      data: [],
	  vip:null,
      listLength: 0,
      show_tz: false,
      number: "",
      sku: []
    }
  },
  created() {
	this.$parent.footer('item');
  },
  mounted() {
    var type = 0;
    if (this.$router.history.current.query.type) {
		this.active = parseInt(this.$router.history.current.query.type);
		type = this.$router.history.current.query.type;
    }
    this.start(type);
  },
  methods: {
	  
    start(type) {
		Fetch('/index/item_search', {
			name: "",
			cate: type
		}).then(r => {
			this.data = r.data;
			this.vip = r.data.vip;
			this.tabs = [{name:'0',title:this.$t('item.all')}].concat(r.data.cates);
			this.listLength = r.data.list.length;
		})
    },
    sort(type) {
		this.start(type);
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  padding: 15px 26px;
}

.red_top_bg {
  height: 44px;
  background-size: 100% 100%;
  position: relative;
  border-radius: 0;
}

.basic_wrap {
  position: relative;
}
.invest {
    display: block;
    padding: 8px;
	padding-top: 0px;
	.intsbox {
	    display: block;
	    margin-top: 10px;
	}
	.itembox {
	    height: 114px;
	    cursor: pointer;
	    margin-bottom: 16px;
	    background: linear-gradient(270deg, #f90,#746b0a);
	    border-radius: 8px;
	    padding: 8px;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    position: relative;
		margin: 8px;
		.thumb {
		    width: 55%;
			img{
				width: 100%;
				height: 97px;
				display: block;
				border-radius: 8px;
			}
		}
		.intro {
		    width: 42%;
		    color: #eee;
			>p {
			    height: 30px;
			    line-height: 30px;
			    font-weight: 500;
			    font-size: 13px;
				>span {
				    margin: 0 2px 0 5px;
				    zoom: 1.1;
				    color: #fff;
				}
			}
		}
		.sicon {
		    position: absolute;
		    right: 0;
		    bottom: 0;
		    z-index: 8;
			img{
				width: 78px;
				height: 60px;
			}
		}
	}
}
.service{
	position: absolute;
	top: 5px;
	right: 6px;
	height: 30px;
	img{
		height: 100%;
	}
}
.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-bottom: 10px;

		.timer {
			padding: 3px 3px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			border-bottom: 1px solid #ececec;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-style: normal;
				padding: 5px;
				border-radius: 5px;
				color: #FFFFFF;
			}

			.ing {
				background: #3775f4;
			}

			.finish {
				font-style: normal;
				background: #07c160;
			}
		}
	}
	.sub_btn{
		width: auto;
		padding: 0 15px;
		margin-right: 5px;
	}
	
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #fff;
	    white-space: nowrap;
		border-radius: 10px;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #ababab;
		    transition: all .3s ease;
			
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.5em;
		    color: #282828;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	
</style>
